document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", () => {
      const arabic = document.querySelector(".nturl[data-gt-lang='ar']")
      const customWeglot = document.querySelectorAll(".custom-language-switch");
      console.log(customWeglot)
      const english = document.querySelector(".nturl[data-gt-lang='en']")
      console.log(english)
      console.log(arabic);

      if (!english || !arabic) return;
      customWeglot.forEach(item => {
        item.addEventListener("click", () => {
          if (english.classList.contains("gt-current")) {
            arabic.click();
            console.log("CLICKED ARABIC");
          } else if (arabic.classList.contains("gt-current")) {
            english.click();
            console.log("CLICKED ENGLISH");
          }
        });
      });
      setTimeout(() => {
        // Pages can have one or two switches; label every one that exists.
        if(english.classList.contains("gt-current")){
          customWeglot.forEach(item => { item.textContent = "العربية" })
        } else if(arabic.classList.contains("gt-current")){
          customWeglot.forEach(item => { item.textContent = "English" })
        }
      }, 100);
  });
});